// Session management
export const CHECK_SESSION = 'session.CHECK_SESSION';
export const CHECK_SESSION_SUCCESS = 'session.CHECK_SESSION_SUCCESS';
export const CHECK_SESSION_FAIL = 'session.CHECK_SESSION_FAIL';

// Login/Logout
export const LOG_IN = 'session.LOG_IN';
export const LOG_IN_FAIL = 'session.LOG_IN_FAIL';
export const LOG_OUT = 'session.LOG_OUT';
export const LOG_OUT_SUCCESS = 'session.LOG_OUT_SUCCESS';
export const LOG_OUT_FAIL = 'session.LOG_OUT_FAIL';

// User profile
export const LOAD_USER_PROFILE = 'session.LOAD_USER_PROFILE';
export const LOAD_USER_PROFILE_SUCCESS = 'session.LOAD_USER_PROFILE_SUCCESS';
export const LOAD_USER_PROFILE_FAILURE = 'session.LOAD_USER_PROFILE_FAILURE';
export const UPDATE_USER_PROFILE = 'session.UPDATE_USER_PROFILE';
export const UPDATE_USER_PROFILE_SUCCESS = 'session.UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'session.UPDATE_USER_PROFILE_FAILURE';
export const OPEN_USER_PROFILE_DIALOG = 'session.OPEN_USER_PROFILE_DIALOG';
export const CLOSE_USER_PROFILE_DIALOG = 'session.CLOSE_USER_PROFILE_DIALOG';

// Session heartbeat
export const START_HEARTBEAT = 'session.START_HEARTBEAT';
export const SHOW_SESSION_WARNING = 'session.SHOW_SESSION_WARNING';
export const HIDE_SESSION_WARNING = 'session.HIDE_SESSION_WARNING';
export const EXTEND_SESSION = 'session.EXTEND_SESSION';
export const EXTEND_SESSION_FAILURE = 'session.EXTEND_SESSION_FAILURE';
